import ErrorPage from './errorPage'

export default ErrorPage
